module.exports = __webpack_public_path__ + "a2bd939690e294159b78a019b71cbe1f.wav";